import axios from "axios";
import { environment } from "../../environment";

export const TagsService = () => {
  const search = async (search: string) => {
    try {
      const path = environment.contentUrl + "tags/search/" + search;
      const res = await axios.get(path);
      return res.data;
    } catch (err) {
      throw err;
    }
  };
  return {
    search,
  };
};
